import Button from '@material-ui/core/Button'
import { PageHeader } from '../components/Layout'
import Main from '../components/Layout/Main'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useState } from 'react'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import { FormControl } from '../components/Forms'
import { LoadingButton } from '../components'
import { Buttons } from '../components/Steps'
import { constants, strings } from '../utils'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { publicCallApi } from '../api'
import Error from '../components/Error'
import Success from '../components/Success'

const { lowcase } = strings

const useStyles = makeStyles(() => ({
  paper: {
    padding: '20px',
  },
  center: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },
  margin: {
    /* Remove marginTop to keep buttons aligned horizontally */
  },
}))

const RequestInclusion = () => {
  const classes = useStyles()
  const history = useHistory()
  const { search } = useLocation()

  const params = new URLSearchParams(search)
  const offerId = params.get('offerId')
  const schoolId = params.get('schoolId')

  const [loading, setLoading] = useState(false)
  const [alreadyStudying, setAlreadyStudying] = useState(false)
  const [notStudying, setNotStudying] = useState(false)
  const [changeStudentStatus, setchangeStudentStatus] = useState(false)
  const [user, setUser] = useState('')
  const [password, setPassword] = useState('')
  const [notFound, setNotFound] = useState(false)
  const [foundStudent, setFoundStudent] = useState(false)
  const [error, setError] = useState(false)
  const [schoolInfo, setSchoolInfo] = useState(null)
  const [success, setSuccess] = useState(false)
  const [offerInfo, setOfferInfo] = useState(null)

  const shouldDisableSearchButton = () =>
    `${user}`.length < 4 || `${password}`.length < 4 || loading

  const tryToLogin = (user, password) => async () => {
    setLoading(true)

    const response = await publicCallApi.validateUser(
      user,
      password,
      offerId
    )

    const { ok, status } = response

    if (ok && (status === 200 || status === 201)) {
      const offerInfoResponse = await response.json()
      setFoundStudent(true)
      setOfferInfo(offerInfoResponse);
      setAlreadyStudying(false)
    } else {
      setNotFound(true)
    }

    setLoading(false)
  }

  const submitWaitlistInclusion = async () => {
    setLoading(true)
    const response = await publicCallApi.insertWaitingList(offerId, user)

    const { ok, status } = response

    if (ok && (status === 200 || status === 201)) {
      setSuccess(true)
    } else {
      setError(true)
    }

    setLoading(false)
  }

  const retrieveSchoolInfo = async () => {
    setLoading(true)

    const response = await publicCallApi.getSchoolInfo(schoolId)

    const { ok, status } = response

    if (ok && (status === 200 || status === 201)) {
      const responseBody = await response.json()

      setSchoolInfo(responseBody.school_info)

      setNotStudying(true)
      setchangeStudentStatus(true)
    }

    setLoading(false)
  }

  const handleAlreadyStudying = () => {
    setAlreadyStudying(true)
    setchangeStudentStatus(true)
  }

  return (
    <>
      <PageHeader title="Solicitar Inclusão na Fila de Espera" />

      <Main>
        {!changeStudentStatus && (
          <Grid item xs={12}>
            <Buttons extraClasses={classes.row}>
              <Button variant="contained" color="primary" onClick={handleAlreadyStudying}>
                Já estudo na rede
              </Button>
              <LoadingButton
                className={classes.margin}
                disabled={loading}
                loading={loading}
                onClick={retrieveSchoolInfo}
              >
                Não estudo na rede
              </LoadingButton>
              <Button variant="contained" color="primary" onClick={() => history.push(constants.routes.waitingList.path)}>
                Voltar
              </Button>
            </Buttons>
          </Grid>
        )}

        {notStudying && (
          <>
            <Typography variant="h6" component="h2">
              Entre em contato com a escola para que seja providenciada a inclusão na fila de espera.
            </Typography>
            <Typography
              component="h3"
              color="textSecondary"
              style={{ marginTop: '8px' }}
            >
              Segue contato:&nbsp; <br />
              {schoolInfo.ancestry_name && (
                <>
                  <strong>SRE:</strong> {schoolInfo.ancestry_name || "não informado"}&nbsp;
                  | <strong>Telefone:</strong> {schoolInfo.ancestry_phone || "não informado"}&nbsp;
                  | <strong>Endereço:</strong> {schoolInfo.ancestry_address || "não informado"}&nbsp;
                  | <strong>Cidade:</strong> {schoolInfo.ancestry_city || "não informado"}&nbsp;
                  | <strong>Estado:</strong> {schoolInfo.ancestry_state || "não informado"}.<br />
                </>
              )}
              <strong>Escola:</strong> {schoolInfo.school_name || "não informado"}&nbsp;
              | <strong>Telefone:</strong> {schoolInfo.school_phone || "não informado"}&nbsp;
              | <strong>Endereço:</strong> {schoolInfo.school_address || "não informado"}&nbsp;
              | <strong>Cidade:</strong> {schoolInfo.school_city || "não informado"}&nbsp;
              | <strong>Estado:</strong> {schoolInfo.school_state || "não informado"}.
            </Typography>

            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: '20px 0',
                }}
              >

                <Button variant="contained" color="primary" onClick={() => history.push(constants.routes.waitingList.path)}>
                  Voltar
                </Button>
              </div>
            </Grid>
          </>
        )}

        {alreadyStudying && (
          <>
            {notFound && (
              <>
                <Grid item xs={12} className={classes.error}>
                  <Error>
                    Não foi possível encontrar o aluno, verifique usuário e senha.
                  </Error>
                </Grid>
              </>
            )}

            <div style={{ paddingTop: 20 }}>
              <Grid item md={6} xs={12}>
                <FormControl>
                  <TextField
                    autoFocus
                    type="user"
                    disabled={loading}
                    label="Usuário"
                    name="user"
                    value={user || ''}
                    variant="outlined"
                    onChange={e => setUser(lowcase(e.target.value))}
                  />
                </FormControl>
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControl>
                  <TextField
                    type="password"
                    disabled={loading}
                    label="Senha"
                    name="password"
                    value={password || ''}
                    variant="outlined"
                    onChange={e => setPassword(e.target.value)}
                  />
                </FormControl>
              </Grid>
            </div>

            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: '20px 0',
                }}
              >
                <Buttons extraClasses={classes.row}>
                  <LoadingButton
                    variant="contained"
                    className={classes.margin}
                    disabled={shouldDisableSearchButton()}
                    loading={loading}
                    onClick={tryToLogin(user, password)}
                  >
                    Consultar
                  </LoadingButton>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.margin}
                    onClick={() => history.push(constants.routes.waitingList.path)}
                  >
                    Voltar
                  </Button>
                </Buttons>
              </div>
            </Grid>
          </>
        )}

        {foundStudent && (
          <>
            {error && (
              <>
                <Grid item xs={12} className={classes.error}>
                  <Error>
                    Não foi possível adicionar o aluno a lista de espera.
                  </Error>
                </Grid>
              </>
            )}

            {success && (
              <>
                <Grid item xs={12} className={classes.success}>
                  <Success>
                    Inclusão na lista de espera realizada com sucesso!
                  </Success>
                </Grid>
              </>
            )}

            <Typography style={{ paddingTop: 20 }} variant="h6" component="h2">
              Deseja ser incluído na lista de espera? <br />
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {offerInfo.school_info.ancestry_name && (
                <>Unidade Funcional: {offerInfo.school_info.ancestry_name}</>
              )}
              {offerInfo.school_info.ancestry_phone && (
                <> | Telefone: {offerInfo.school_info.ancestry_phone}</>
              )}
              {offerInfo.school_info.ancestry_address && (
                <> | Endereço: {offerInfo.school_info.ancestry_address}</>
              )}
              {offerInfo.school_info.ancestry_address && (
                <> | Cidade: {offerInfo.school_info.ancestry_city}</>
              )}
              {offerInfo.school_info.ancestry_address && (
                <> | Estado: {offerInfo.school_info.ancestry_state}</>
              )}
              <br />
              {offerInfo.data.attributes.schoolName && (
                <>Escola: {offerInfo.data.attributes.schoolName}</>
              )}
              {offerInfo.data.attributes.cityName && (
                <> | Cidade: {offerInfo.data.attributes.cityName}</>
              )}
              {offerInfo.data.attributes.label && (
                <> | Oferta: {offerInfo.data.attributes.label}</>
              )}
            </Typography>

            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: '20px 0',
                }}
              >
                <Buttons extraClasses={classes.row}>
                  <LoadingButton
                    className={classes.margin}
                    disabled={loading || success}
                    loading={loading}
                    onClick={submitWaitlistInclusion}
                  >
                    Confirmar inclusão na Fila de Espera
                  </LoadingButton>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => history.push(constants.routes.waitingList.path)}
                  >
                    Voltar
                  </Button>
                </Buttons>
              </div>
            </Grid>
          </>
        )}


      </Main >
    </>
  )
}

export default RequestInclusion
